import { render, staticRenderFns } from "./CommessaExtra.vue?vue&type=template&id=258e52b5&scoped=true&"
import script from "./CommessaExtra.vue?vue&type=script&lang=js&"
export * from "./CommessaExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258e52b5",
  null
  
)

export default component.exports